import { Component, inject } from '@angular/core';
import { ActiveModalService } from '../ui/modal/modal.service';
import { TranslateModule } from '@ngx-translate/core';
import { LogoComponent } from '../ui/header/logo/logo.component';

@Component({
  selector: 'app-start',
  imports: [TranslateModule, LogoComponent],
  templateUrl: './start.component.html',
  styleUrl: './start.component.css'
})
export class StartComponent {

  private modal = inject(ActiveModalService)

  protected close() {
    this.modal.destroy()
  }

}
